export type LanguageCode = 'enUS' | 'deDE' | 'frFR' | 'itIT' | 'esES' | 'esMX' | 'ptBR' | 'ruRU'

// ISO 3166-1 alpha-2 codes used to look up SVG flag components from country-flag-icons.
export type CountryCode = 'US' | 'DE' | 'FR' | 'IT' | 'ES' | 'MX' | 'BR' | 'RU'

export const LANGUAGES = [
  { code: 'enUS' as LanguageCode, label: 'English', countryCode: 'US' as CountryCode, url: '' },
  { code: 'deDE' as LanguageCode, label: 'Deutsch', countryCode: 'DE' as CountryCode, url: 'de/' },
  { code: 'frFR' as LanguageCode, label: 'Français', countryCode: 'FR' as CountryCode, url: 'fr/' },
  { code: 'itIT' as LanguageCode, label: 'Italiano', countryCode: 'IT' as CountryCode, url: 'it/' },
  { code: 'esES' as LanguageCode, label: 'Español', countryCode: 'ES' as CountryCode, url: 'es/' },
  { code: 'esMX' as LanguageCode, label: 'Español (Mexico)', countryCode: 'MX' as CountryCode, url: 'mx/' },
  { code: 'ptBR' as LanguageCode, label: 'Português (Brasil)', countryCode: 'BR' as CountryCode, url: 'pt/' },
  { code: 'ruRU' as LanguageCode, label: 'Русский', countryCode: 'RU' as CountryCode, url: 'ru/' },
]

export const getLocaleURL = (locale: LanguageCode): string => {
  return LANGUAGES.find(lang => lang.code === locale)?.url ?? ''
}

// Maps our internal locale codes (enUS, deDE, …) to proper BCP-47 language
// tags (en-US, de-DE, …) for use with Intl APIs (date/number formatting).
export const toBcp47Locale = (locale: string): string => {
  const code = LANGUAGES.find(lang => lang.code === locale)?.code ?? 'enUS'
  return `${code.slice(0, 2)}-${code.slice(2)}`
}